export default "<p>donate works!</p>\r\n"